// Demo isometric for the landing page (DN150 from a real hand drawing).
export const DEMO_ISO = {
  pipe_diameter: "DN150",
  segments: [
    { axis: "-X", length_mm: 547, offset_axis: "-Y", offset_mm: 389 },
    { axis: "+Z", length_mm: 733 },
    { axis: "-Y", length_mm: 1830 },
    { axis: "-Z", length_mm: 424 },
    { axis: "+X", length_mm: 395, offset_axis: "-Z", offset_mm: 281 },
  ],
  fittings: [
    { type: "flange", segment: 1, position_mm: 127 },
    { type: "reducer", segment: 3, position_mm: 259 },
    { type: "valve", segment: 3, position_mm: 569 },
    { type: "reducer", segment: 3, position_mm: 879 },
  ],
};
